import React, { useState } from 'react'
import FilterDrawer from 'components/FilterDrawer/FilterDrawer'
import { Filter, FilterAdditionalData } from 'components/FilterDrawer/FilterDrawer.config'
import { FilterOptions } from 'containers/CDTFATablePage/types'
import { FilterOutlined } from '@ant-design/icons'
import styles from './VerticalTableFilters.module.scss'

interface VerticalTableFiltersProps {
  activeFilters: Filter[]
  setActiveFilters: React.Dispatch<React.SetStateAction<Filter[]>>
  filtersInitialState: Filter[]
  filterOptions: FilterOptions
  filterAdditionalData: FilterAdditionalData[]
}

const VerticalTableFilters = ({
  activeFilters,
  setActiveFilters,
  filtersInitialState,
  filterOptions,
  filterAdditionalData,
}: VerticalTableFiltersProps) => {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false)
  return (
    <>
      <FilterOutlined onClick={() => setIsFilterDrawerOpen(!isFilterDrawerOpen)} className={styles.filterIcon} />
      <FilterDrawer
        open={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        activeFilters={activeFilters}
        setActiveFilters={setActiveFilters}
        filtersInitialState={filtersInitialState}
        filterOptions={filterOptions}
        filterAdditionalData={filterAdditionalData}
      />
    </>
  )
}

export default VerticalTableFilters
